import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M6.75 6.75V16C6.75 16.6904 7.30964 17.25 8 17.25H17.25M6.75 6.75H4M6.75 6.75V4M17.25 17.25V20M17.25 17.25H20M17.25 14.75V8C17.25 7.30964 16.6904 6.75 16 6.75H9.25" vectorEffect="non-scaling-stroke" />
	</SVG>
);
